import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

export default function SearchBox({
  value,
  onChange,
  placeholder = "Rechercher",
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}) {
  return (
    <div
      className="d-flex align-items-center gap-2 px-3 flex-grow-1"
      style={{
        height: 38,
        minWidth: 200,
        maxWidth: 360,
        borderRadius: 999,
        fontSize: 13,
        border: "1px solid #e5e5e5",
        backgroundColor: "#fff",
      }}
    >
      <MagnifyingGlassIcon color="gray" width={18} />
      <input
        type="text"
        placeholder={placeholder}
        className="border-0 w-100 bg-transparent"
        style={{ outline: "none", fontSize: 13 }}
        value={value}
        onChange={(e) => onChange(e.target.value.toLowerCase())}
      />
    </div>
  );
}
